import { form } from 'formifier';

const dfsErrorMessages = {
  Name: {
    valueMissing: 'Please enter your first and last name.',
    tooLong: 'Please enter 255 characters or less for your first name.'
  },
  Children: {
    patternMismatch: 'Please enter a number.'
  },
  Email: {
    valueMissing: 'Please enter your email address.',
    patternMismatch: 'Please enter a valid email address.',
    tooLong: 'Please enter 80 characters or less for your email address.'
  },
  Phone: {
    valueMissing: 'Please enter your phone number.',
    patternMismatch: 'Please enter a valid phone number.',
    tooLong: 'Please enter 25 characters or less for the phone number.'
  },
  City: {
    valueMissing: 'Please enter your city.',
    tooLong: 'Please enter 64 characters or less for the price.'
  },
  Country: {
    tooLong: 'Please enter 80 characters or less for  your your country.'
  },
  DateOfVisit: {
    valueMissing: "Please enter a date you'd like to visit us."
  },
  TypeOfVisit: {
    valueMissing: 'Please select one.'
  },
  DebtAmount: {
    valueMissing: 'Please tell us how much debt you paid off.',
    patternMismatch: 'Please enter a number.'
  },
  DebtType: {
    valueMissing: 'Please tell us what kind of debt you had.',
    tooLong: 'Please enter 255 characters or less.'
  },
  SoldAssets: {
    valueMissing: 'Please select one.'
  },
  SoldAssetAmount: {
    tooLong: 'Please enter 255 characters or less.'
  },
  RamseyProductDetails: {
    tooLong: 'Please enter 255 characters or less.'
  },
  PayoffTime: {
    valueMissing: 'Please tell us how long it took you to pay off your debt.',
    tooLong: 'Please enter 255 characters or less.'
  },
  DateOfPayoff: {
    valueMissing: 'Please tell us the date you paid off your last debt.'
  },
  StartingIncome: {
    valueMissing: 'Please tell us your starting income.',
    patternMismatch: 'Please enter a number.'
  },
  EndingIncome: {
    valueMissing: 'Please tell us your ending income.',
    patternMismatch: 'Please enter a number.'
  },
  AdditionalIncome: {
    tooLong: 'Please enter 255 characters or less.'
  },
  CreditCard: {
    valueMissing: 'Please select one.'
  },
  Financing: {
    valueMissing: 'Please select one.'
  },
  UsedRetirement: {
    valueMissing: 'Please select one.'
  },
  FinancingNotes: {
    tooLong: 'Please enter 255 characters or less.',
    valueMissing:
      'This field is required if you answered "Yes" to any of the Financial Habits questions above.'
  },
  Terms: {
    valueMissing: 'You must agree to the terms before you can submit.'
  }
};

form(dfsErrorMessages, document.getElementById('debt-free-scream-form'));
